import { PasswordFeedback, PasswordStrength, PasswordValidationResult } from '../../types/password'

const feedbacks = [
  { limit: PasswordStrength.VeryStrong, feedback: PasswordFeedback.VeryStrong },
  { limit: PasswordStrength.Strong, feedback: PasswordFeedback.Strong },
  { limit: PasswordStrength.Moderate, feedback: PasswordFeedback.Moderate },
  { limit: PasswordStrength.Weak, feedback: PasswordFeedback.Weak },
  { limit: PasswordStrength.VeryWeak, feedback: PasswordFeedback.VeryWeak },
  { limit: PasswordStrength.Nothing, feedback: PasswordFeedback.Nothing }
]

const calculatePasswordFeedback = ({
  strength,
  requirements
}: {
  strength: number
  requirements: { label: string; isMet: boolean }[]
}): PasswordValidationResult => {
  const feedback = feedbacks.find(({ limit }) => strength >= limit)!.feedback
  return { feedback, strength, requirements }
}

export default calculatePasswordFeedback
